/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_cards_fees_rule_wallet = /** @type {(inputs: { wallet: NonNullable<unknown> }) => string} */ (i) => {
	return `Para billetera ${i.wallet}`
};

const en_cards_fees_rule_wallet = /** @type {(inputs: { wallet: NonNullable<unknown> }) => string} */ (i) => {
	return `For ${i.wallet} wallet`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ wallet: NonNullable<unknown> }} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const cards_fees_rule_wallet = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cards_fees_rule_wallet(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cards_fees_rule_wallet", locale)
	if (locale === "es") return es_cards_fees_rule_wallet(inputs)
	return en_cards_fees_rule_wallet(inputs)
};
export { cards_fees_rule_wallet as "cards.fees.rule_wallet" }